import type { ReactNode } from 'react';

export interface SetupCardProps {
  /** Optional mono, uppercase label rendered above the content. */
  label?: ReactNode;
  /** Card content. */
  children: ReactNode;
  /** Extra classes appended to the card wrapper. */
  className?: string;
}

/**
 * Setup card with an optional label.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged.
 */
export function SetupCard({ label, children, className = '' }: SetupCardProps) {
  return (
    <div className={`card p-4 ${className}`}>
      {label && (
        <label className="font-mono text-[10px] uppercase tracking-wider text-ink-3 mb-2 block">
          {label}
        </label>
      )}
      {children}
    </div>
  );
}
